import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async pedidos(pedido) {
    const response = await api.post(API_URL + "pedidos", pedido);
    if (response.data) return response.data;
  },

  async detallePedido(pedido) {
    const response = await api.post(API_URL + "detallePedido", pedido);
    if (response.data) return response.data;
  },

  async generarPedido(user) {
    try {
      const response = await api.post(API_URL + "generarPedido", user);
      return response.data;
    } catch (e) {
      const status = e?.response?.status;
      const msg = e?.response?.data?.mensaje || e?.response?.data?.message;
      if (status === 410) return { res: "NOK", mensaje: msg || "Servicio expirado" };
      return { res: "NOK", mensaje: msg || "Error generando el pedido" };
    }
  },

  async estadoPedidoPago(payload) {
    const response = await api.post(API_URL + "pedido/estado-pago", payload);
    return response.data;
  },

  async confirmarPagado(user) {
    const response = await api.post(API_URL + "confirmarPagado", user);
    if (response.data) return response.data;
  },

  async confirmarTrial(payload) {
    try {
      const response = await api.post(API_URL + "confirmarTrial", payload);
      return response.data;
    } catch (e) {
      const msg = e?.response?.data?.mensaje || e?.response?.data?.message;
      return { res: "NOK", mensaje: msg || "Error confirmando el periodo de prueba" };
    }
  },

  async tipsterProductoCompradores(payload) {
    const response = await api.post(API_URL + "tipster/productos/compradores", payload ?? {});
    return response.data;
  },

  async exportarPedidos() {
    return await api.post(API_URL + "pedidos/export", {}, { responseType: "blob" });
  },
};
